import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react'

import { ICellEditorParams } from 'ag-grid-community'
import CreatableSelect from 'react-select/creatable'

export const DelayReasonCellEditor = forwardRef(function MultiSelectOptionsEditor(
  props: ICellEditorParams & { options: any[]; isMulti: boolean },
  ref
) {
  const { options, value } = props
  const defaultValue = useMemo(
    () => {
      return value
        ?.split(',')
        .map((v) => (v ? options.find((opt) => opt.label === v) || { value: v, label: v } : v))
    },
    [props.value] || []
  )
  const [innerValue, setInnerValue] = useState(defaultValue)
  const [outterValue, setOutterValue] = useState(value)
  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return outterValue
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false
      },
    }
  })

  return (
    <div className='w-[400px] p-4'>
      <CreatableSelect
        instanceId='delay-reason-select'
        isMulti={true}
        isClearable={false}
        className='w-full'
        options={options}
        value={innerValue}
        onChange={(newValue) => {
          setInnerValue(newValue)
          setOutterValue(newValue?.map((v) => v.value).join(', '))
        }}
      />
    </div>
  )
})
